import {convertCoordinates} from '@/api/util-coordinates';

class NationalParkApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    name,
    province,
    region,
    cx,
    cy,
    // visible,
    id,
    url,
  }) {
    return {
      name,
      province,
      region,
      id,
      url,
      coordinates: convertCoordinates(cx, cy),
      visible: false, // TODO: Quitar cuando esté en la api
    };
  }
}

export default NationalParkApiResponseModel;
